import React, { useEffect, useState } from "react";
import TableContainer from "../../components/table/table-container";
import Button from "../../components/buttons/button";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/pagination/pagination";
import search from "../../assets/icons/searchIcon.svg";
import { useDispatch } from "react-redux";
import { listProductAction } from "../../redux/actions/productAction";
import { errorToast } from "../../components/notifications/toast";
import Loader from "../../components/loaders/dot-loader";

const Products = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState("");
    const [paginationData, setPaginationData] = useState(null);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        console.log("Current Page:", page);
    };

    const handleEdit = (productId) => {
        navigate(`/products/edit-product/${productId}`);
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(searchValue);
            setCurrentPage(1)
        }, 300);

        return () => {
            clearTimeout(handler);
        };
    }, [searchValue]);

    useEffect(() => {
        fetchProducts()
    }, [currentPage, debouncedValue])

    const fetchProducts = () => {
        setLoading(true)
        dispatch(listProductAction({ page: currentPage, search: debouncedValue, page_size: 10 }, onSuccess, onError))
    }


    const onSuccess = (data) => {
        setProducts(data.data.data.products);
        setPaginationData(data.data.data.pagination)
        setLoading(false)
    }

    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
        setLoading(false)
    }

    return (
        <TableContainer>
            <div className="flex flex-col sm:flex-row justify-between px-2 pb-2 w-full">
                <div className="w-full sm:w-auto">
                    {/* Bread crumb data */}
                    <div
                        style={{ height: "2.5rem" }}
                        className={`input_border flex items-center rounded-md w-full sm:w-auto mx-1 md:w-80`}
                    >
                        <span className="px-2">
                            <img width={"16px"} src={search} alt="search icon" />
                        </span>
                        <input
                            placeholder={`Search here`}
                            className="table_search_input w-full rounded-md fs_12 placeholder:text-fs_12"
                            type="text"
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e?.target?.value);
                            }}
                        />
                        <span className='fs_14 mx-3 cursor-pointer text-primary' onClick={() => setSearchValue('')} >Clear</span>
                    </div>
                </div>

                <div className="w-full sm:w-auto mt-2 sm:mt-0">
                    <Button onClick={() => navigate('/products/create-product')} variant="primary" size="md" className="w-full sm:w-auto">
                        Create Product
                    </Button>
                </div>
            </div>

            <div className="relative">
                <div className="overflow-auto border border-gray-300 rounded-md" style={{ height: '45rem' }}>
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-100 sticky top-0">
                                <th className="p-2 border border-gray-200 font-medium text-left">#</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Code</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Image</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Name</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Category</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">UOM</th>
                                <th className="p-2 border border-gray-200 font-medium text-right">PTS</th>
                                <th className="p-2 border border-gray-200 font-medium text-right">PTR</th>
                                <th className="p-2 border border-gray-200 font-medium text-right">MRP</th>
                                <th className="p-2 border border-gray-200 font-medium text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="10" style={{ height: '35rem' }}>
                                        <Loader />
                                    </td>
                                </tr>
                            ) : products.length > 0 ? products.map((product, index) => (
                                <tr key={product.id} className="hover:bg-gray-50">
                                    <td className="px-2 border border-gray-200">{(currentPage - 1) * paginationData?.pageSize + (index + 1)}</td>
                                    <td className="px-2 border border-gray-200 text-left">{product?.code}</td>
                                    <td className="px-2 border border-gray-200">
                                        {product?.image ?
                                            <img
                                                src={product?.image}
                                                alt={product?.name}
                                                className="w-16 h-14 object-cover rounded-md truncate"
                                            />
                                            : <div className="py-2">--</div>
                                        }
                                    </td>
                                    <td className="px-2 border border-gray-200 text-left">{product?.name}</td>
                                    <td className="px-2 border border-gray-200 text-left">{product?.category?.name}</td>
                                    <td className="px-2 border border-gray-200 text-left">{product?.uom}</td>
                                    <td className="px-2 border border-gray-200 text-right">{product?.pts}</td>
                                    <td className="px-2 border border-gray-200 text-right">{product?.ptr}</td>
                                    <td className="px-2 border border-gray-200 text-right">{product?.mrp}</td>
                                    <td className="px-2 border border-gray-200 text-center">
                                        <button
                                            onClick={() => handleEdit(product?.id)}
                                            className="text-blue-500 hover:underline"
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                            )) :
                                <tr>
                                    <td colSpan="10" style={{ height: '35rem' }}>
                                        <span className="text-gray-400 font-extralight"> No Data Found</span>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="flex justify-end mt-2 bottom-0 right-0">
                <Pagination
                    totalPages={paginationData?.totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            </div>
        </TableContainer>
    );
};

export default Products;
